import React from 'react';
import AnimatedNumber from './AnimatedNumber';

class StatItem3 extends React.Component {
    render() {
        const {
            title,         // string
            value,         // string or number
            message1,      // string
            type = 1,
            colorValue = '#E0582C',
            colorMessage1 = '#212121',
            bgColor = '#F5FBFF',
            bgColor2 = '#F5FBFF', // ✅ mặc định bgColor2
            isBorder = false, // 🆕 mặc định là false
        } = this.props;

        const containerStyle = {
            display: 'flex',
            background: `linear-gradient(to right, ${bgColor}, ${bgColor2})`, // ✅ sử dụng gradient
            borderRadius: 12,
            padding: 24,
            width: 'calc(100% - 48px)',
            height: 'calc(100% - 48px)',
            border: isBorder ? '1px solid rgba(255, 255, 255, 1)' : 'none',
            backdropFilter: 'blur(10px)', // ✅ thêm hiệu ứng blur
            WebkitBackdropFilter: 'blur(10px)', // ✅ hỗ trợ Safari
          };

        if(type == 1)
        {
            return (
         <div style={{ ...containerStyle, flexDirection: 'column', justifyContent: 'center' }}>

                    
                     <div style={{fontFamily:'Inter28-SemiBold', fontSize: 64, fontWeight: 500, color: colorValue, display: 'flex', flexDirection: 'row', alignContent:'center' }}>
                     <AnimatedNumber value={value} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center',  display: 'flex', flexDirection: 'row', alignContent:'center'  }}>
                        <div style={{ fontSize: 24, color: '#212121', fontWeight: 600}}>{title}</div>
                    </div>
                  
                    <div style={{ fontSize: 16, fontWeight: 400, color: colorMessage1, marginTop: 10, textAlign:'left' }}>
                                {message1}
                    </div>
    
                </div>
            );
        } else if(type == 3)
            {
                return (
                    <div style={{ ...containerStyle, flexDirection: 'column', justifyContent: 'center' }}>

                        <div style={{ display: 'flex', alignItems: 'center',  display: 'flex', flexDirection: 'row', alignContent:'center'  }}>
                            <div style={{ fontSize: 24, color: '#212121', fontWeight: 600}}>{title}</div>
                        </div>
                         <div style={{fontFamily:'Inter28-SemiBold', fontSize: 64, fontWeight: 500, color: colorValue, display: 'flex', flexDirection: 'row', alignContent:'center' }}>
                         <AnimatedNumber value={value} />
                         </div>
                      
                      
                        <div style={{ fontSize: 16, fontWeight: 400, color: colorMessage1, marginTop: 10, textAlign:'left' }}>
                                    {message1}
                        </div>
        
                    </div>
                );
            } else {
            return (
                <div style={{ ...containerStyle, flexDirection: 'row' }}>

                    
                     <div style={{fontFamily:'Inter28-SemiBold', fontSize: 64, fontWeight: 500, color: colorValue, display: 'flex', flexDirection: 'row', alignContent:'center' }}>
                     <AnimatedNumber value={value} />
                     </div>
                    <div style={{ display: 'flex',
                    flexDirection: 'column', marginLeft: 16,justifyContent:'center'}}>
                        <div style={{ display: 'flex', alignItems: 'center',  display: 'flex', flexDirection: 'row', alignContent:'center'  }}>
                            <div style={{ fontSize: 24, color: '#212121', fontWeight: 600}}>{title}</div>
                        </div>
                    
                        <div style={{ fontSize: 16, fontWeight: 400, color: colorMessage1, marginTop: 10, textAlign:'left' }}>
                                    {message1}
                        </div>
                    </div>
                   
    
                </div>
            );
        }
      
    }
}

export default StatItem3;
